import Architecture from "../../../../docs/_images/architecture.png";
import * as React from 'react';
export default {
  Architecture,
  React
};